// Before Send to Live: say what Live won't reproduce of the browser's edits.
// Presentation only — the counting is lib/live-differences.ts.

import { useQuery } from "@tanstack/react-query";
import type { SeedApiDetail } from "@shared/api-types.js";
import type { Snapshot } from "@shared/seed-history.js";
import { webApi } from "@web-shared/lib/web-api";
import { liveDifferences, liveDifferencesText } from "@/lib/live-differences";

export function LiveDifferencesNote({ seedId }: { seedId: string }) {
  const seed = useQuery({
    queryKey: ["web", "seed-for-live", seedId],
    queryFn: () => webApi<SeedApiDetail>(`/seeds/${encodeURIComponent(seedId)}`),
    staleTime: 60_000,
  });
  const text = seed.data ? liveDifferencesText(liveDifferences(seed.data.arrangement as Snapshot | null)) : null;
  if (!text) return null;
  return <p className="mt-3 rounded-xl border border-white/10 bg-white/[0.03] p-3 text-xs text-muted-foreground">{text}</p>;
}
